import React from 'react'
import { Col, Row } from 'reactstrap'

const PanelCommitment = () => {
  return (
    <div id='website-responsive' className='pt-md-5 pb-md-5'>
        <div className='left-padding5rem1 right-padding5rem1 pt-md-5 pt-4 pb-md-4 pb-4' style={{ backgroundColor:'#f2f2f2', height:'80%', width:'100%' }}>
        <Row className='re'>    
            <Col md='6' className=''>
                <div className=''>
                    <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                        OUR COMMITMENT
                    </div>
                    <hr className='hr-style my-md-1' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>

                <div className='py-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    United Lab Care provides extensive testing scopes with reliable and accurate laboratory services. We aim to provide you with information about the lab and Respiratory pathogen panel testing services that you can rely on as being accurate, authoritative, and independent. 
                    </div>
                </div>

                <div className='pt-3'>
                    <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                    Our services provide excellent<strong> Laboratory Testing in Chicago,</strong> where we perform standard and customized lab tests.
                    </div>
                </div>
            </Col>

            <Col md='6' className='flex-center'>
                <div className='m-check' style={{ marginTop:''}}>
                    <div className='' style={{ backgroundImage:"url('panel-testing/ULC-Services-bg1-v1.webp')", height:'auto', backgroundSize:'contain', backgroundRepeat:'no-repeat', padding:'1rem 4rem 8rem 1rem'}}>
                        <ul className='fs-ss-13 text-montserrat text-white fw-700 pt-2'>
                            <li className='pb-2'>International standard facilities</li>
                            <li className='pb-2'>Scientifically designed infrastructure</li>
                            <li className='pb-2'>Sophisticated & high accuracy<br/> measuring instruments</li>
                            <li className='pb-2'>Easy & Effective Monitoring</li>
                            <li className='pb-2'>Reliable & Comprehensive Testing<br/> Solutions</li>
                            <li className='pb-2'>Accurate & Consistent Testing</li>
                            <li className='pb-2'>Proven & Trusted Quality Control</li>
                        </ul>
                    </div>
                </div>
            </Col>
        </Row>
            

            
        </div>
    </div>
  )
}

export default PanelCommitment